import { z } from 'zod'

import { DateZod } from '../../../common'

export const PiloteVolunteerRecordZod = z.object({
  central_id: z.number(),
  id: z.number(),
  is_active: z.boolean(),
  is_archived: z.coerce
    .boolean()
    .nullable()
    .transform((value) => value ?? false),
  uuid: z.string(),
  request_count: z.number().nullish(),
  total_donations: z.number().nullish(),
  total_mileage: z.number().nullish(),
  presence_count_for_current_campaign: z.number().nullish(),
  participation_number_of_years: z.number().nullish(),
  registration_count: z.number().nullish(),
})

export const PiloteVolunteerCompleteRecordZod = z.object({
  id: z.number(),
  central_id: z.number(),
  organization_id: z.number().nullable(),
  is_driver: z.coerce.boolean(),
  is_partner: z.coerce.boolean(),
  is_escort: z.coerce.boolean(),
  creation_date: DateZod,
  first_partner_first_name: z.string().nullable(),
  first_partner_last_name: z.string().nullable(),
  second_partner_first_name: z.string().nullable(),
  second_partner_last_name: z.string().nullable(),
  is_french_communication: z.number(z.coerce.boolean()),
})
